import React, { useCallback, useContext } from 'react';

export const StandaloneLoadingContext = React.createContext<{
	beginLoading: () => void;
	endLoading: () => void;
}>({
	beginLoading: () => {},
	endLoading: () => {},
});

const useStandalonePageLoader = () => {
	const { beginLoading, endLoading } = useContext(StandaloneLoadingContext);

	const withLoading = useCallback(
		async <T,>(request: () => Promise<T>): Promise<T> => {
			beginLoading();
			try {
				return await request();
			} finally {
				requestAnimationFrame(() => {
					requestAnimationFrame(endLoading);
				});
			}
		},
		[beginLoading, endLoading]
	);

	return { beginLoading, endLoading, withLoading };
};

export default useStandalonePageLoader;
